import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form as FormikForm } from "formik";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import Loading from "components/NewLoading";
import { actions } from "store/reducers/companies";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import formSchema from "./schemas/form";
import Form from "./Form";

function UltiproConfiguration() {
  const { formId, formField } = formSchema;
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const companyId = null;

  const onSubmit = useCallback(
    (formValues, cb) => {
      setSubmitting(true);
      dispatch(
        actions.storeUltipro(
          companyId,
          formValues,
          (data) => {
            dispatch(actions.addSettings(data));
            toast.success("Company ultipro setting successfully saved");
            setSubmitting(false);
          },
          (msg, error) => {
            toast.error(msg);
            setSubmitting(false);
            cb(error);
          }
        )
      );
    },
    [dispatch, setLoading, companyId]
  );

  const { settings } = useSelector((state) => state.companies);

  useEffect(() => {
    if (!settings.fetched || !settings.company) {
      setLoading(true);
      dispatch(
        actions.fetchSettings(
          (err) => {
            toast.error(err);
            setLoading(false);
          },
          () => setLoading(false)
        )
      );
    }
  }, []);

  const company = useSelector((state) => state.companies.settings.company);
  const ultipro = useMemo(() => company?.ultipro, [company]);

  if (loading || !ultipro) {
    return (
      <Card>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Loading className="grey" />
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <Formik
        initialValues={initialValues}
        validationSchema={validations}
        enableReinitialize
        onSubmit={(values, formik) => {
          formik.validateForm().then((res) => {
            if (res) {
              onSubmit(values, (err) => {
                console.log(err);
                if (err && err.errors && Array.isArray(err.errors) && err.errors.length) {
                  const formErrors = {};
                  err.errors.forEach((e) => {
                    if (e.key && formField[e.key] && e.error) {
                      formErrors[e.key] = e.error;
                    }
                  });
                  console.log(formErrors);
                  if (Object.keys(formErrors).length) {
                    formik.setErrors(formErrors);
                  }
                }
                formik.setSubmitting(false);
              });
            }
          });
        }}
      >
        {({ values, errors, touched, setValues }) => {
          useEffect(() => {
            if (ultipro) {
              setValues(ultipro);
            }
          }, [ultipro, setValues]);

          return (
            <FormikForm id={formId} autoComplete="new-password">
              <DialogContent dividers>
                <Form
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />
              </DialogContent>
              <DialogActions>
                <MDButton disabled={submitting} type="submit" variant="gradient" color="info">
                  {submitting ? "Saving..." : "Save"}
                </MDButton>
              </DialogActions>
            </FormikForm>
          );
        }}
      </Formik>
    </Card>
  );
}

export default UltiproConfiguration;
